import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const Home = ({ setView, user }) => {
	  let buttons = [
		      { label: "Train (via AI Avatar Simulations)", view: "simulations2", variant: "contained" },
		      { label: "Receive (Analytics & Coaching for most recent Training)", view: "conversationreview", variant: "outlined" },
		      { label: "Reflect (Historical Trends to Plan next Improvements)", view: "history", variant: "contained" },
		    ];

	  if (user.username == 'jayson.vincent@daughertyenterprises.com') {
	   buttons = [...buttons,
		      { label: "Configure (Parameters)", view: "homedetailed" }
	   ];
	  }

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Welcome, {user.name}!
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				           <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default Home;

